package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.core.Page
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("socket_ktor")
@Composable
fun SocketKtorPage() {
    BlogLayout(
        PageProperties(
            "Socket KTOR",
            ""),
        BlogProperties("KTOR", "Socket")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            KotlinCode(
                code = """
                    install(WebSockets) {
                        contentConverter = KotlinxWebsocketSerializationConverter(Json)
                         
                        pingPeriod = Duration.parse("PT1000S")
                        //pingPeriod = Duration.ofSeconds(15)
                        
                        timeout = Duration.parse("PT1000S")
                        //timeout = Duration.ofSeconds(15)
                        
                        maxFrameSize = Long.MAX_VALUE
                        masking = false
                    }
                """.trimIndent()
            )

            KotlinCode(
                code = """
                    install(Sessions) {
                        cookie<UserSession>("user_session") {
                            cookie.path = "/"
                            cookie.maxAgeInSeconds = 60
                        }
                    }
                """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    lateinit var chatCredential: UserPasswordCredential
                    
                    val connections = Collections.synchronizedSet<Connection?>(LinkedHashSet())
                    
                    val userName = call.principal<UserIdPrincipal>()?.name.toString()
                    val userSession = call.sessions.get<UserSession>()
                    thisConnection.name = chatCredential.name
                    connections += thisConnection
                    connections.distinct().forEach {
                        it.session.send("You are connected! There are ${connections.count()} users here.")
                    }
                    
                    //session null
                     val session = call.sessions.get<ChatSession>()
                     if(session == null){
                        close(CloseReason(CloseReason.Codes.VIOLATED_POLICY, "No session."))
                        return@webSocket
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Serializable
                    data class UserSession(val name: String, val count: Int)

                    fun Application.configureAuth() {
                        install(Sessions) {
                            cookie<UserSession>("user_session") {
                                cookie.path = "/"
                                cookie.maxAgeInSeconds = 60
                            }
                        }
                        install(Authentication) {
                            basic("auth-basic") {
                                realm = "Access to the '/' path"
                                validate { credentials ->

                                    chatCredential = credentials
                                    val user = DatabaseRepository.getUsers().find {
                                        it.username == credentials.name && it.password == credentials.password
                                    }

                                    if (user != null) {
                                        UserIdPrincipal(credentials.name)
                                    } else {
                                        null
                                    }
                                }
                            }
                            session<UserSession>("auth-session") {
                                validate { session ->
                                    if(session.name.isNotBlank()) {
                                        session
                                    } else {
                                        null
                                    }
                                }
                                challenge {
                                    call.respondRedirect("/login")
                                }
                            }
                        }

                        routing {
                            authenticate("auth-basic") {
                                post("/login") {
                                    val userName = call.principal<UserIdPrincipal>()?.name.toString()
                                    if(call.sessions.get<UserSession>()?.name != userName) {
                                        call.sessions.set(UserSession(name = userName, count = 1))
                                    }
                                    call.respond(Json.encodeToString(DatabaseRepository.getUsers().find { it.username == userName }))
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

